/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import GoalsidGoal from './GoalsidGoal';

/**
 * The GoalsIdBody model module.
 * @module model/GoalsIdBody
 * @version v0.3
 */
export default class GoalsIdBody {
  /**
   * Constructs a new <code>GoalsIdBody</code>.
   * @alias module:model/GoalsIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>GoalsIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GoalsIdBody} obj Optional instance to populate.
   * @return {module:model/GoalsIdBody} The populated <code>GoalsIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new GoalsIdBody();
      if (data.hasOwnProperty('goal'))
        obj.goal = GoalsidGoal.constructFromObject(data['goal']);
    }
    return obj;
  }
}

/**
 * @member {module:model/GoalsidGoal} goal
 */
GoalsIdBody.prototype.goal = undefined;

